module.exports = __webpack_public_path__ + "img/knife_widowmaker.b86e1e20.svg";